import { Route, Redirect } from 'react-router-dom';

import { IUserRoles, useUserState } from 'contexts/user';
import { isPermitted } from 'utils/validate';
import { config } from 'config';

interface IRoutePrivateProps {
  permission: IUserRoles,
  isBIView?: boolean;
  [x: string]: any
}

const RoutePrivate = ({ permission, isBIView, ...rest }: IRoutePrivateProps) => {
  const { isLogin, user } = useUserState();
  const authorized = isPermitted((user.role || 'GUEST'), permission)

  return isLogin ? (
    (authorized && (!isBIView || user.has_bi_access)) ? (
      <Route {...rest} />
    ) : (
      <Redirect to={{
          pathname: `/${config.game}/dashboard/unauthorized`,
        state: { referrer: (rest.path || '') }
      }} />
    )
  ) : (
    <Redirect to={'/auth/login'} />
  );
};

export default RoutePrivate;
